import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {styles} from "./SummaryImageStyles";
const useStyles = makeStyles(styles);

const ScanRateImage = () => {
    const classes = useStyles();

    return (
        <Fragment>
            <div style={{textAlign: 'center'}}>
                <img src={require('../../../assets/images/ScanRate.svg')} alt={'alt'} style={{width: '23px'}} className={classes.image}/>
            </div>
        </Fragment>
    )
}

export default ScanRateImage;
